import React, {FC} from 'react';
import styled from 'styled-components';
import {Grid} from '../../../../atoms/Grid/Grid';
import {FilterSingleSelectOptions} from '../../FilterContent/FilterSingleSelectOptions/FilterSingleSelectOptions';
import {FilterDropdown} from '../FilterDropdown';

interface Props {
  activeOptionId?: string;
  dataTestId?: string;
  label: string;
  options: Array<{id: string; label: string}>;
  onFilterReset: () => void;
  onSelect: (itemId: string) => void;
  hasAppliedDiscount: boolean;
  onOpen?: () => void;
  onClose?: () => void;
}

export const FilterDropdownDiscountLevel: FC<Props> = ({
  activeOptionId,
  dataTestId = 'filterFlyoutDiscountLevel',
  hasAppliedDiscount,
  label,
  options,
  onFilterReset,
  onSelect,
  onOpen,
  onClose,
  ...props
}) => {
  const discountCount = hasAppliedDiscount ? 1 : 0;

  return (
    <FilterDropdown
      dataTestId="filterFlyoutDiscountLevel"
      activeCount={discountCount}
      label={label}
      onReset={onFilterReset}
      onClose={onClose}
      onOpen={onOpen}
      filterContent={
        <Wrapper data-testid={`${dataTestId}Wrapper`} {...props}>
          <FilterSingleSelectOptions
            activeOptionId={activeOptionId}
            data-testid={dataTestId}
            onSelect={onSelect}
            options={options}
            Wrapper={OptionWrapper}
          />
        </Wrapper>
      }
    />
  );
};

const OptionWrapper = styled(Grid).attrs(() => ({columns: 3}))`
  grid-gap: 0;
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
